//#region Function Imports
import React, { useState, useEffect } from 'react'
import { FlatList, StyleSheet, Platform, SafeAreaView, View, useWindowDimensions } from 'react-native'
import { useAuthContext } from "../../../hooks/useAuthContext";
import { useAssessment } from '../../../hooks/useAssessment';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import CustomButton from '../../../components/CustomButton/CustomButton';
import CustomInput from '../../../components/CustomInput';
import CustomParticipants from "../../../components/AssessmentBuilderCmponent/Participants/CustomParticipants";
import { Card } from 'react-native-paper';
import { useTheme } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import PopUpPart from "../../../components/AssessmentBuilderCmponent/PopUpPart/PopUpPart";
import CustomDropDownWithIcons from '../../../components/CustomDropDownWithIcons';

//#endregion

const ParticipantsScreen = ({
    assm,
    assmUi,
    setAssmUi,
    wfl,
    workflows,
    setShowParticipationsScreen,
    showParticipationScreen,
    setShowResponseScreen,
    setShowEditScreen,
    setShowEditGroup,
    setShowCreateGroup,
    setShowCreateScreen,
    setShowMyAssessments,
    setShowAssessmentsAdmin,
}) => {

    //#region Function Consts
    const { t } = useTranslation();
    const { width, height } = useWindowDimensions();
    const { user, clientApi, username } = useAuthContext();
    const { loadEveryEmployee, loadParticipants, deleteParticipant, ToggleActive, ToggleSubmit } = useAssessment();
    const { colors } = useTheme();
    const styles = makeStyles(colors, height, width);
    const wflObj = workflows.find((obj) => obj.assmType === wfl);
    const steps = wflObj ? wflObj.numberOfSteps : 0;
    const stepOptions = [
        { label: "All", value: 0 },
        ...Array.from({ length: steps }, (_, i) => ({ label: (i + 1).toString(), value: i + 1 })),
    ];
    const [searchFlag, setSearchFlag] = useState(0);
    const [searchPart, setSearchPart] = useState("");
    const [selectedStep, setSelectedStep] = useState(0);
    const [showEditParticipant, setShowEditParticipant] = useState(0);
    const [goBack, setGoBack] = useState(0)
    const [loading, setLoading] = useState(false);
    const [partEdit, setPartEdit] = useState([{}])
    const [showCustomParticipants, setShowCustomParticipants] = useState(0);
    const [participants, setParticipants] = useState([]);
    const [showSubmitted, setShowSubmitted] = useState(0);
    const [refresh, setRefresh] = useState(0);
    const [showUnsubmitted, setShowUnsubmitted] = useState(0);
    const [employeesList, setEmployeesList] = useState([]);

    useEffect(
        () => { },
        [width, height]
    );

    const loadParticipations = () => {
        loadParticipants(assmUi)
            .then((respEmployee) => {
                setParticipants(respEmployee);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    // * This will load the Authorized employees only. All employees are the only the employees that the users is authorized to see
    const loadEmployees = () => {
        loadEveryEmployee(clientApi, user.token, username)
            .then((respEmployee) => {
                setEmployeesList(respEmployee);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const handleShowSubmitted = () => {
        setShowSubmitted(!showSubmitted)
        if (showUnsubmitted == true)
            setShowUnsubmitted(!showUnsubmitted)
    };

    const handleShowUnsubmitted = () => {
        setShowUnsubmitted(!showUnsubmitted)
        if (showSubmitted == true)
            setShowSubmitted(!showSubmitted)
    };

    const handleGoBack = async () => {
        setAssmUi(assmUi)
        setGoBack(1)
    };

    const handleGoForWard = async () => {
        setShowParticipationsScreen(0)
        setShowResponseScreen(0)
        setShowEditGroup(0)
        setShowCreateGroup(0)
        setShowCreateScreen(0)
        setShowMyAssessments(0)
        setShowAssessmentsAdmin(1)
        setShowEditScreen(0)
    };

    useEffect(() => {
        if (goBack === 1) {
            setShowParticipationsScreen(0)
            setShowResponseScreen(0)
            setShowEditGroup(0)
            setShowCreateGroup(0)
            setShowCreateScreen(0)
            setShowMyAssessments(0)
            setShowAssessmentsAdmin(0)
            setShowEditScreen(1)
        }
    }, [assmUi, goBack]);

    useEffect(() => {
        loadParticipations();
        setRefresh(0);
    }, [showCustomParticipants, showParticipationScreen, refresh]);

    useEffect(() => {
        loadEmployees();
    }, [showCustomParticipants]);

    useEffect(() => {
        if (searchPart === "")
            setSearchFlag(0)
    }, [searchPart]);

    const handleAddParticipant = () => {
        setShowCustomParticipants(1);
        setShowEditParticipant(0);
    }

    const handleEditParticipant = (item) => {
        setRefresh(1);
        getParticipantsForAppraisee(item.appraiseeName)
        setShowCustomParticipants(0);
        setShowEditParticipant(1);
    }

    function getParticipantsForAppraisee(appraiseeName) {
        const filteredParticipants = participants.filter(
            (participant) => participant.appraiseeName === appraiseeName
        );
        setPartEdit(filteredParticipants)
    }

    const handleDeleteParticipant = (item) => {
        setRefresh(1);
        console.log("Deleting...")
        deleteParticipant(clientApi, user.token, username, item.assmEmplUI)
            .then((resp) => {
                //* Reload Participants
                setRefresh(0);
            })
            .catch((error) => {
                console.error(error);
            });
    }

    const handleDeleteAllParticipant = () => {
        setRefresh(1);
        participants.forEach((participant) => {
            deleteParticipant(clientApi, user.token, username, participant.assmEmplUI)
                .then((resp) => {
                    setRefresh(0);
                    console.log("Deleting Participants...")
                })
                .catch((error) => {
                    console.error(`Error deleting participant ${participant.assmEmplUI}:`, error);
                });
        });
        setRefresh(1);
    }

    const toggleActive = (item) => {
        ToggleActive(clientApi, user.token, username, item.assmEmplUI)
            .then((resp) => {
                setRefresh(1)
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const toggleSubmit = (item) => {
        ToggleSubmit(clientApi, user.token, username, item.assmEmplUI)
            .then((resp) => {
                setRefresh(1)
            })
            .catch((error) => {
                console.error(error);
            });
    };

    //#region Render Functions
    const ParticipantsScreenListView = (item) => {
        return (
            <View style={styles.showhide}>
                <SafeAreaView>
                    <SafeAreaView style={styles.item}>
                        <SafeAreaView style={styles.row}>
                            <CustomLabel
                                value={item.appraiseeName}
                                type='AVAILABLEUSED' />
                            <CustomLabel
                                value={item.appraiseeID}
                                type='AVAILABLEUSED' />
                            <CustomLabel
                                value={item.appraiserName}
                                type='AVAILABLEUSED' />
                            <CustomLabel
                                value={item.appraiserID}
                                type='AVAILABLEUSED' />
                            <CustomLabel
                                value={item.stage}
                                type='AVAILABLEUSED' />
                            <View style={styles.button}>
                                <CustomButton
                                    iconName='pencil-outline'
                                    onPress={() => { handleEditParticipant(item) }}
                                    show='HOME_BELL'
                                    type='HOME_BELL'
                                    textTop='2'
                                    sz={20} />
                                <CustomButton
                                    iconName='trash-outline'
                                    onPress={() => { handleDeleteParticipant(item) }}
                                    show='HOME_BELL'
                                    type='HOME_BELL'
                                    textTop='2'
                                    sz={20} />
                            </View>
                            <View style={styles.button}>
                                {item.active === false ?
                                    <CustomButton
                                        iconName="square-outline"
                                        onPress={() => {
                                            Swal.fire({
                                                title: "Are you sure?",
                                                text: "Are you sure you want to toggle Active State of the Participant?",
                                                icon: "question",
                                                showCancelButton: true,
                                                reverseButtons: true,
                                                cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Cancel</text>`,
                                                cancelButtonColor: '#d3d3d3',
                                                confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Toggle</text>`,
                                                confirmButtonColor: '#A0A2FF',
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    toggleActive(item)
                                                }
                                            });
                                        }}
                                        show='HOME_BELL'
                                        type='HOME_BELL'
                                        textTop='2'
                                        sz={20} />
                                    : <CustomButton
                                        iconName="checkbox-outline"
                                        onPress={() => {
                                            Swal.fire({
                                                title: "Are you sure?",
                                                text: "Are you sure you want to toggle Active State of the Participant?",
                                                icon: "question",
                                                showCancelButton: true,
                                                reverseButtons: true,
                                                cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Cancel</text>`,
                                                cancelButtonColor: '#d3d3d3',
                                                confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Toggle</text>`,
                                                confirmButtonColor: '#A0A2FF',
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    toggleActive(item)
                                                }
                                            });
                                        }}
                                        show='HOME_BELL'
                                        type='HOME_BELL'
                                        textTop='2'
                                        sz={20} />
                                }
                                {item.submitted === false ?
                                    <CustomButton
                                        iconName="square-outline"
                                        onPress={() => {
                                            Swal.fire({
                                                title: "Are you sure?",
                                                text: "Are you sure you want to toggle Submit State of the Participant?",
                                                icon: "question",
                                                showCancelButton: true,
                                                reverseButtons: true,
                                                cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Cancel</text>`,
                                                cancelButtonColor: '#d3d3d3',
                                                confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Toggle</text>`,
                                                confirmButtonColor: '#A0A2FF',
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    toggleSubmit(item)
                                                }
                                            });
                                        }}
                                        show='HOME_BELL'
                                        type='HOME_BELL'
                                        textTop='2'
                                        sz={20} />
                                    : <CustomButton
                                        iconName="checkbox-outline"
                                        onPress={() => {
                                            Swal.fire({
                                                title: "Are you sure?",
                                                text: "Are you sure you want to toggle Submit State of the Participant?",
                                                icon: "question",
                                                showCancelButton: true,
                                                reverseButtons: true,
                                                cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Cancel</text>`,
                                                cancelButtonColor: '#d3d3d3',
                                                confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Toggle</text>`,
                                                confirmButtonColor: '#A0A2FF',
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    toggleSubmit(item)
                                                }
                                            });
                                        }}
                                        show='HOME_BELL'
                                        type='HOME_BELL'
                                        textTop='2'
                                        sz={20} />
                                }
                            </View>
                        </SafeAreaView>
                    </SafeAreaView>
                </SafeAreaView>
            </View>
        )
    }

    const checkSearch = (item) => {
        if (searchFlag) {
            if ((item.appraiseeName == searchPart) || (item.appraiserName == searchPart) || (item.appraiseeID == searchPart) || (item.appraiserID == searchPart)) {
                return true;
            } else { return false; }
        } else { return true; }
    };

    const renderParticipants = ({ item }) => {
        if (selectedStep != 0) {
            if (showUnsubmitted == true) {
                if (item.submitted == false && (item.stage == selectedStep)) {
                    if (checkSearch(item))
                        return (<Card
                            style={styles.cardstyle} >
                            <Card.Content>
                                <ParticipantsScreenListView {...item} />
                            </Card.Content>
                        </Card>)
                    else { return (<></>) }
                } else { return (<></>) }
            } else if (showSubmitted == true) {
                if (item.submitted == true && (item.stage == selectedStep)) {
                    if (checkSearch(item))
                        return (<Card
                            style={styles.cardstyle} >
                            <Card.Content>
                                <ParticipantsScreenListView {...item} />
                            </Card.Content>
                        </Card>)
                    else { return (<></>) }
                } else { return (<></>) }
            } else {
                if ((item.stage == selectedStep)) {
                    if (checkSearch(item))
                        return (<Card
                            style={styles.cardstyle} >
                            <Card.Content>
                                <ParticipantsScreenListView {...item} />
                            </Card.Content>
                        </Card>)
                    else { return (<></>) }
                } else { return (<></>) }
            }
        } else {
            if (showUnsubmitted == true) {
                if (item.submitted == false) {
                    if (checkSearch(item))
                        return (<Card
                            style={styles.cardstyle} >
                            <Card.Content>
                                <ParticipantsScreenListView {...item} />
                            </Card.Content>
                        </Card>)
                    else { return (<></>) }
                } else { return (<></>) }
            } else if (showSubmitted == true) {
                if (item.submitted == true) {
                    if (checkSearch(item))
                        return (<Card
                            style={styles.cardstyle} >
                            <Card.Content>
                                <ParticipantsScreenListView {...item} />
                            </Card.Content>
                        </Card>)
                    else { return (<></>) }
                } else { return (<></>) }
            } else {
                if (checkSearch(item) === true)
                    return (<Card
                        style={styles.cardstyle} >
                        <Card.Content>
                            <ParticipantsScreenListView {...item} />
                        </Card.Content>
                    </Card>)
                else { return (<></>) }
            }
        }
    };
    //#endregion

    return (
        <SafeAreaView style={styles.main}>
            {showCustomParticipants ? (
                <SafeAreaView>
                    <CustomLabel
                        value={t("common:addparticipations")}
                        type="MINORTITLE" />
                    <CustomParticipants
                        setShowParticipationsScreen={setShowParticipationsScreen}
                        setShowResponseScreen={setShowResponseScreen}
                        setShowEditScreen={setShowEditScreen}
                        setShowEditGroup={setShowEditGroup}
                        setShowCreateScreen={setShowCreateScreen}
                        setShowCreateGroup={setShowCreateGroup}
                        setShowMyAssessments={setShowMyAssessments}
                        setShowAssessmentsAdmin={setShowAssessmentsAdmin}
                        setShowCustomParticipants={setShowCustomParticipants}
                        setShowEditParticipant={setShowEditParticipant}
                        employees={employeesList}
                        wfl={wfl}
                        workflows={workflows}
                        assmid={assmUi}
                        setRefresh={setRefresh}
                        isEdit={0}
                        isCreate={1}
                        toView={0}
                    />
                </SafeAreaView>
            ) : (<>
                {showEditParticipant ? (
                    <SafeAreaView>
                        <CustomLabel
                            value={t("common:editparticipations")}
                            type="MINORTITLE" />
                        <CustomParticipants
                            setShowParticipationsScreen={setShowParticipationsScreen}
                            setShowResponseScreen={setShowResponseScreen}
                            setShowEditScreen={setShowEditScreen}
                            setShowEditGroup={setShowEditGroup}
                            setShowCreateScreen={setShowCreateScreen}
                            setShowCreateGroup={setShowCreateGroup}
                            setShowMyAssessments={setShowMyAssessments}
                            setShowAssessmentsAdmin={setShowAssessmentsAdmin}
                            setShowCustomParticipants={setShowCustomParticipants}
                            setShowEditParticipant={setShowEditParticipant}
                            employees={employeesList}
                            partEdit={partEdit}
                            wfl={wfl}
                            workflows={workflows}
                            assmid={assmUi}
                            setRefresh={setRefresh}
                            isEdit={1}
                            isCreate={0}
                            toView={0}
                        />
                    </SafeAreaView>
                ) : (
                    <></>
                )}
            </>
            )}

            <Card style={[styles.cardstyle_1, { zIndex: -1 }]}>
                {/* //* Search Bar Buttons and Bars  */}
                <View style={[styles.row, { zIndex: 1 }]}>
                    <CustomButton
                        onPress={() => handleShowSubmitted()}
                        iconName={showSubmitted === true ? "funnel" : "funnel-outline"}
                        color="green"
                        show='PART'
                        type='PART'
                        textTop='2'
                        sz={30}
                    />
                    <CustomLabel
                        value={t('common:showsubmitted')}
                        type='PART' />
                    <CustomButton
                        onPress={() => handleShowUnsubmitted()}
                        iconName={showUnsubmitted === true ? "funnel" : "funnel-outline"}
                        show='PART'
                        type='PART'
                        textTop='2'
                        sz={30}
                    />
                    <CustomLabel
                        value={t('common:showunsubmitted')}
                        type='PART' />
                    <CustomDropDownWithIcons
                        defValue={selectedStep}
                        options={stepOptions}
                        value={selectedStep}
                        setValue={setSelectedStep}
                        type='PART'
                    />
                    <CustomInput
                        value={searchPart}
                        setValue={setSearchPart}
                        editable={true}
                        type='PART'
                        placeholder={'Search...'}
                    />
                    <CustomButton
                        iconName='search-outline'
                        onPress={() => setSearchFlag(1)}
                        show='PART'
                        type='PART'
                        textTop='2'
                        sz={20} />
                </View>
                <View style={styles.line} />
                <View
                    style={styles.mainView}>
                    <FlatList
                        data={participants}
                        renderItem={renderParticipants}
                        scrollEnabled={true}
                        refreshing={loading}
                        ListHeaderComponent={
                            <SafeAreaView>
                                <View style={styles.row}>
                                    <CustomLabel
                                        value={t('common:appraiseename')}
                                        type='SUBTITLE' />
                                    <CustomLabel
                                        value={t('common:appraiseeid')}
                                        type='SUBTITLE' />
                                    <CustomLabel
                                        value={t('common:appraisername')}
                                        type='SUBTITLE' />
                                    <CustomLabel
                                        value={t('common:appraiserid')}
                                        type='SUBTITLE' />
                                    <CustomLabel
                                        value={t('common:stage')}
                                        type='SUBTITLE' />
                                    <View style={styles.row}>
                                        <CustomLabel
                                            value={t('common:partfunctionality')}
                                            type='SUBTITLE' />
                                    </View>
                                    <View style={styles.row}>
                                        <CustomLabel
                                            value={t('common:activesubmitted')}
                                            type='SUBTITLE' />
                                        <CustomButton
                                            onPress={() => { handleAddParticipant() }}
                                            iconName='add-outline'
                                            show='HOME_BELL'
                                            type='HOME_BELL'
                                            textTop='2'
                                            sz={30}
                                        />
                                    </View>
                                </View>
                            </SafeAreaView>
                        }
                    />
                </View>
                <Card.Actions>
                    <View style={[styles.row, { zIndex: 2000 }]}>
                        {participants.length === 0 &&
                            <PopUpPart
                                toassmUi={assmUi}
                                setRefresh={setRefresh}
                                wfl={wfl}
                            />
                        }
                        <CustomButton
                            iconName='trash-outline'
                            onPress={() => { handleDeleteAllParticipant() }}
                            show='PART'
                            type='PART'
                            textTop='0'
                            sz={25} />
                    </View>
                </Card.Actions>
            </Card>
            <View style={styles.GoBackContainer} >
                <CustomButton
                    onPress={() => handleGoBack()}
                    iconName="chevron-back-outline"
                    show='PART'
                    type='PART'
                    textTop='2'
                    isGradient={true}
                    sz={30}
                />
                <View style={{ marginHorizontal: 5, flexDirection: 'row', alignItems: 'center' }}>
                    <CustomLabel value={t('common:goback')} type='SUBTITLE' />
                </View>
                <CustomButton
                    onPress={() => handleGoForWard()}
                    iconName="chevron-forward-outline"
                    show='PART'
                    type='PART'
                    textTop='2'
                    isGradient={true}
                    sz={30}
                />
            </View>
        </SafeAreaView>
    );
};

const makeStyles = (colors, height, width) => StyleSheet.create({
    mainView: {
        height: (Platform.OS === 'web' ? height * 60 / 100 : '95%'),
        justifyContent: 'center'
    },
    main: {
        flex: 1,
        alignItems: "center",
        padding: "10%",
    },
    line: {
        borderBottomColor: colors.buttons_primary,
        borderBottomWidth: StyleSheet.hairlineWidth,
        marginTop: "1%",
        marginBottom: "1%",
    },
    cardstyle: {
        backgroundColor: colors.background_white,
        borderWidth: 1,
        borderColor: colors.border_card,
        borderRadius: 14,
        shadowColor: 'rgba(92, 143, 26, 1)',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.08,
        shadowRadius: 12,
        elevation: 3,
        overflow: 'hidden',
        marginVertical: 16,
    },
    cardstyle_1: {
        padding: 10,
        margin: 10,
        width:
            Platform.OS === "web" && width > 1300
                ? width - (width * 30) / 100
                : (width * 80) / 100,
        borderRadius: 35,
        backgroundColor: colors.background_card,
        elevation: 10,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
    },
    row: {
        flex: 1,
        flexDirection: "row"
    },
    button: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
        alignSelf: "center",
        alignItems: "center",
    },
    GoBackContainer: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
    },
})

export default ParticipantsScreen;

